<template>
  <div class="rentsreturn">
    <div class="t1">退款中</div>
    <div class="t2">￥{{deposit}}</div>
    <div class="t3">租金将在7个工作日退回</div>
    <div class="app-btn-area weui-btn-area">
      <div @click="goback" class="weui-btn" replace>确定</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      deposit:0
    }
  },
  created(){
    this.deposit = this.$route.query.deposit
  },
  methods:{
    goback(){
      this.$router.go(-1)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/rentsreturn.vue